<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-tent"
        title="รายงานข้อมูลลูกเสือวิสามัญอาชีวศึกษา"
        class="px-5 py-3"
      >
        <!-- ===== ตัวกรอง ===== -->
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filters.filter_region_ID"
              label="ภาค"
              :items="region"
              item-text="region_name"
              item-value="region_ID"
              clearable
              dense
              @change="onRegionChange"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filters.filter_province_ID"
              label="จังหวัด"
              :items="filteredProvince"
              item-text="province_name"
              item-value="province_ID"
              clearable
              dense
              @change="reloadAll"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filters.college_code"
              label="วิทยาลัย"
              :items="college"
              item-text="college_name"
              item-value="college_code"
              clearable
              dense
              @change="reloadAll"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filters.scout_level"
              label="ระดับลูกเสือ"
              :items="scout_levels"
              clearable
              dense
              @change="reloadAll"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="filters.scout_position"
              label="ตำแหน่งทางลูกเสือ"
              :items="scout_positions"
              clearable
              dense
              @change="reloadAll"
            ></v-select>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="filters.search"
              append-icon="mdi-magnify"
              label="ค้นหา ชื่อ-สกุล / ตำแหน่ง / วิทยาลัย"
              single-line
              hide-details
              dense
              filled
              @keyup.enter="reloadAll"
              @click:append="reloadAll"
            />
          </v-col>
          <v-col cols="12" md="3" class="text-right">
            <v-btn color="success" outlined :loading="exporting" @click="exportExcel">
              <v-icon left>mdi-file-excel</v-icon>
              ส่งออก Excel
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>

      <!-- ===== ตารางข้อมูล (server-side paging) ===== -->
      <base-material-card icon="mdi-table" title="รายการข้อมูล" class="px-5 py-3 mt-4">
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="rows"
          :items-per-page="filters.per_page"
          :server-items-length="total"
          :options.sync="tableOptions"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          loading-text="กำลังโหลดข้อมูล..."
          no-data-text="ไม่พบข้อมูล"
        >
          <template v-slot:item.fullname="{ item }">
            {{ item.title_s }}{{ item.frist_name }} {{ item.last_name }}
          </template>
          <template v-slot:item.scout_instructor="{ item }">
            <v-chip v-if="item.scout_instructor === 'เป็น'" x-small color="success" dark>วิทยากร</v-chip>
            <span v-else>-</span>
          </template>
          <template v-slot:item.woodbadge_date="{ item }">
            <span v-if="item.woodbadge_date">
              {{ item.woodbadge_date | moment("add", "543 years") | moment("D MMM YYYY") }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.source_type="{ item }">
            <v-chip x-small outlined>{{ item.source_type === "self" ? "เพิ่มโดยตนเอง" : "เพิ่มโดยวิทยาลัย" }}</v-chip>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>

    <v-snackbar v-model="snackbar.show" :timeout="4000" :color="snackbar.color" top right>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment-timezone";

export default {
  name: "PersonnelScoutReport",

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      exporting: false,
      total: 0,
      rows: [],
      college: [],
      region: [],
      province: [],
      scout_levels: [
        "ลูกเสือสำรอง",
        "ลูกเสือสามัญ",
        "ลูกเสือสามัญรุ่นใหญ่",
        "ลูกเสือวิสามัญ"
      ],
      scout_positions: [
        "ผู้อำนวยการลูกเสือโรงเรียน",
        "รองผู้อำนวยการลูกเสือโรงเรียน",
        "ผู้กำกับลูกเสือ(กลุ่ม/กอง)",
        "รองผู้กำกับลูกเสือ(กลุ่ม/กอง)",
        "ผู้ช่วยผู้กำกับลูกเสือ(กลุ่ม/กอง)",
        "วิทยากรลูกเสือ",
        "ผู้ตรวจการลูกเสือ/ผู้ช่วยผู้ตรวจการลูกเสือ",
        "กรรมการลูกเสือ/กรรมการบริหารลูกเสือ",
        "เจ้าหน้าที่ลูกเสือ",
        "อื่น ๆ"
      ],

      filters: {
        search: "",
        college_code: null,
        scout_level: null,
        scout_position: null,
        filter_province_ID: null,
        filter_region_ID: null,
        page: 1,
        per_page: 25
      },

      tableOptions: {},

      headers: [
        { text: "วิทยาลัย", align: "left", value: "college_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ภาค", align: "left", value: "region_name" },
        { text: "ชื่อ-สกุล", align: "left", value: "fullname", sortable: false },
        { text: "ระดับลูกเสือ", align: "left", value: "scout_level" },
        { text: "ตำแหน่ง", align: "left", value: "scout_position" },
        { text: "วุฒิ", align: "left", value: "scout_qualification" },
        { text: "วันที่ได้รับวูดแบดจ์", align: "center", value: "woodbadge_date" },
        { text: "ประสบการณ์(ปี)", align: "center", value: "scout_experience_year" },
        { text: "วิทยากร", align: "center", value: "scout_instructor" },
        { text: "แหล่งที่มา", align: "center", value: "source_type" }
      ],

      snackbar: { show: false, color: "", text: "" }
    };
  },

  computed: {
    filteredProvince() {
      if (!this.filters.filter_region_ID) return this.province;
      return this.province.filter(p => p.region_ID === this.filters.filter_region_ID);
    }
  },

  watch: {
    tableOptions: {
      handler(opt) {
        this.filters.page = opt.page || 1;
        this.filters.per_page = opt.itemsPerPage || 25;
        this.loadList();
      },
      deep: true
    }
  },

  async mounted() {
    await Promise.all([this.loadCollege(), this.loadRegionProvince()]);
    await this.reloadAll();
  },

  methods: {
    onRegionChange() {
      this.filters.filter_province_ID = null;
      this.reloadAll();
    },

    async reloadAll() {
      this.filters.page = 1;
      await this.loadList();
    },

    async loadCollege() {
      let result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.college = result.data;
    },

    async loadRegionProvince() {
      let [regionRes, provinceRes] = await Promise.all([
        this.$http.post("region.php", { ApiKey: this.ApiKey }),
        this.$http.post("province.php", { ApiKey: this.ApiKey })
      ]);
      this.region = regionRes.data;
      this.province = provinceRes.data;
    },

    async loadList() {
      this.loading = true;
      try {
        let result = await this.$http.post("personnel_scout_report.php", {
          ApiKey: this.ApiKey,
          action: "list",
          ...this.filters
        });
        this.rows = result.data.data || [];
        this.total = result.data.total || 0;
      } catch (e) {
        this.showSnackbar("error", "โหลดข้อมูลไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    parseAwards(raw) {
      try {
        const arr = JSON.parse(raw || "[]");
        return Array.isArray(arr) ? arr.join(", ") : "";
      } catch (e) {
        return "";
      }
    },

    async exportExcel() {
      this.exporting = true;
      try {
        let result = await this.$http.post("personnel_scout_report.php", {
          ApiKey: this.ApiKey,
          action: "export",
          search: this.filters.search,
          college_code: this.filters.college_code,
          scout_level: this.filters.scout_level,
          scout_position: this.filters.scout_position,
          filter_province_ID: this.filters.filter_province_ID,
          filter_region_ID: this.filters.filter_region_ID
        });

        const rows = result.data.data || [];
        if (!rows.length) {
          this.showSnackbar("warning", "ไม่มีข้อมูลให้ส่งออกตามตัวกรองนี้");
          return;
        }

        const exportData = rows.map(item => ({
          วิทยาลัย: item.college_name,
          จังหวัด: item.province_name,
          ภาค: item.region_name,
          คำนำหน้าชื่อ: item.title_s,
          ชื่อ: item.frist_name,
          นามสกุล: item.last_name,
          ระดับลูกเสือ: item.scout_level,
          เหล่าลูกเสือ: item.scout_type,
          ตำแหน่งทางลูกเสือ: item.scout_position === "อื่น ๆ" ? item.scout_position_other : item.scout_position,
          วุฒิ: item.scout_qualification,
          วันที่ได้รับวูดแบดจ์: item.woodbadge_date
            ? moment(item.woodbadge_date).add(543, "years").format("D MMMM YYYY")
            : "",
          ประสบการณ์ปี: item.scout_experience_year,
          วิทยากร: item.scout_instructor === "เป็น" ? "เป็น" : "ไม่เป็น",
          เครื่องหมายที่ได้รับ: this.parseAwards(item.scout_awards)
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ข้อมูลลูกเสือ");
        const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          `รายงานข้อมูลลูกเสือ_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
      } catch (e) {
        this.showSnackbar("error", "ส่งออกข้อมูลไม่สำเร็จ");
      } finally {
        this.exporting = false;
      }
    },

    showSnackbar(color, text) {
      this.snackbar = { show: true, color, text };
    }
  }
};
</script>
